import { useEffect, useState } from "react"

import { getAgents } from "@/lib/api"
import type { Agent } from "@/types/api"

/** Selectable agents for the slash menu (default/orchestrator are implicit). `loaded` is true once the request settled. */
export function useAgents(): { agents: Agent[]; loaded: boolean } {
  const [agents, setAgents] = useState<Agent[]>([])
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    let cancelled = false
    getAgents()
      .then((all) => {
        if (!cancelled) setAgents(all.filter((a) => a.id !== "default" && a.id !== "orchestrator"))
      })
      .catch(() => {
        // agents are an enhancement — chat works without them
      })
      .finally(() => {
        if (!cancelled) setLoaded(true)
      })
    return () => {
      cancelled = true
    }
  }, [])

  return { agents, loaded }
}
